module.exports = __webpack_public_path__ + "static/media/catalog-active.97a609f3.svg";